'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule? obj: { default: obj };
}

var Avatar = function Avatar(_ref) {
  var mention = _ref.mention;
  var _ref$theme = _ref.theme;
  var theme = _ref$theme === undefined? {}: _ref$theme;


  if (mention.get('avatar')) {
    return _react2.default.createElement('img', {
      src: mention.get('avatar'),
      className: theme.mentionSuggestionsEntryAvatar,
      role: 'presentation'
    });
  }

  if (mention.get('firstName')) {
    var diskNumber = mention.get('iconId');
    var diskClass = 'avatar-' + diskNumber;

    var letters = getAvatarLetters(mention.get('firstName'), mention.get('secondName'));
    return _react2.default.createElement(
      'span',
      {
        className: '' + theme.mentionSuggestionsEntryAvatar + ' ' + diskClass,
        role: 'presentation'
      },
      letters
    );
  }

  return null;
};

function getAvatarLetters(firstName, secondName) {
  var firstLetter = firstName && firstName.charAt(0) || '';
  var lastLetter;

  if (secondName) {
    lastLetter = secondName && secondName.charAt(0) || '';
  } else {
    var everythingAfterAtSymbol = /@.*$/;
    var everythingAfterPlusSymbol = /\+.*$/;
    var nonLetters = /[^a-zA-Z]+/;
    var strParts = firstName
      .replace(everythingAfterAtSymbol, '')
      .replace(everythingAfterPlusSymbol, '')
      .split(nonLetters);

    lastLetter = strParts.length > 1 && strParts[1].charAt(0) || '';
  }
  return (firstLetter + lastLetter).toUpperCase();
}

exports.default = Avatar;



//////////////////
// WEBPACK FOOTER
// ./assets/js-lib/draft-js-mention-plugin/MentionSuggestions/Entry/Avatar/index.js
// module id = 609
// module chunks = 0